import { Component, HostListener } from '@angular/core';

@Component({
  selector: 'app-animated-ball-banner',
  templateUrl: './animated-ball-banner.component.html',
  styleUrls: ['./animated-ball-banner.component.scss']
})
export class AnimatedBallBannerComponent {
  scrollY = 0;

  @HostListener('window:scroll', [])
  onScroll() {
    this.scrollY = window.scrollY;
  }

  getStyle(position: string) {
    const maxScroll = 300;
    const progress = Math.min(this.scrollY / maxScroll, 1);

    let x = 0, y = 0,zIndex = 2;
    let top = '0px', left = '0px';

    switch (position) {
      case 'red':
        x = -window.innerWidth * 0.3 * (1 - progress);
        y = -window.innerHeight * 0.3 * (1 - progress) - 0 * progress; // shift slightly up
        zIndex = 2;
       top = '65px';
      left = '60px';
        break;
      case 'green':
        x = window.innerWidth * 0.3 * (1 - progress);
        y = 0;
        zIndex = 1;
        break;
      case 'blue':
        x = -window.innerWidth * 0.3 * (1 - progress);
        y = window.innerHeight * 0.3 * (1 - progress) + 0 * progress; // shift slightly down
        zIndex = 3;
        top = '130px';
        left = '125px';
        break;
    }

    return {
      transform: `translate(${x}px, ${y}px)`,
      zIndex,
      top,
    left,
    };
  }


  getTitleStyle() {
    const maxScroll = 300;
    const progress = Math.min(this.scrollY / maxScroll, 1);
    const y = -150 + 350 * progress; // move title down to center
    const opacity = 1 - 0.5 * (1 - progress);
    return {
      transform: `translate(-35%, ${y}px)`,
      opacity: opacity
    };
  }
  

}
